import { PlaylistAdd, OpenInNew } from '@mui/icons-material';
import { Box, Button, Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { Link } from 'react-router-dom';

type AgreementsListHeaderProps = {
  activeAgreementsCount: number;
  activeJournalsCount: number;
  repository?: string;
};

export const AgreementsListHeader = ({
  activeAgreementsCount,
  activeJournalsCount,
  repository,
}: AgreementsListHeaderProps) => {
  const { t } = useTranslation();
  const { impersonationLock } = useAuthContext();

  return (
    <Card
      variant="default"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 3,
      }}
    >
      <Box>
        <Typography component="h1" variant="h4" gutterBottom>
          {t('agreements.title')}
        </Typography>
        <Typography variant="body1">
          Create or edit your agreements for your public search
        </Typography>
        <Typography component="p" variant="subtitle1" sx={{ marginTop: 4 }}>
          You have {activeAgreementsCount} active agreements with a total of{' '}
          {activeJournalsCount} journals in your public search.
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column' },
          gap: 10,
          mt: { xs: 10, md: 0 },
        }}
      >
        <Button
          component={Link}
          to="/agreements/add"
          variant="primary"
          sx={{ whiteSpace: 'nowrap' }}
          endIcon={<PlaylistAdd />}
          disabled={impersonationLock}
        >
          {t('agreements.addAgreement')}
        </Button>
        {repository && (
          <Button
            component="a"
            href={repository}
            target="_blank"
            rel="noreferrer"
            variant="link"
            sx={{ whiteSpace: 'nowrap' }}
            endIcon={<OpenInNew />}
          >
            Internal Repository Link
          </Button>
        )}
      </Box>
    </Card>
  );
};
